import React, { useEffect } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import { useFeatureLoyaltyUi } from 'hooks/use-feature-loyalty-ui';
import { useAuthContext } from 'state/auth';
import { useCdpContext } from 'state/cdp';
import { CustomEventNames, EVENT_PAGE_NAMES, EventTypes } from 'state/cdp/constants';
import { useLocationContext } from 'state/location';

import { LoyaltyRewardsMemo } from '../loyalty-rewards';

import {
  InlineCarouselWrapper,
  OfferRewardContainer,
  PageTitleContainer,
  PageTitleText,
  RewardsTitle,
  RewardsTitleRow,
  StyledButton,
} from './loyalty-offers-rewards.styled';
import { LoggedOutView } from './offers-rewards-logged-out-state';

export const OffersRewards = () => {
  const { isAuthenticated } = useAuthContext();
  const isLoggedIn = isAuthenticated();

  const { trackEvent } = useCdpContext();
  const {
    location: { search, pathname },
  } = useLocationContext();

  const { formatMessage } = useIntl();

  const { featureLoyaltyUi } = useFeatureLoyaltyUi();
  const rewardsPath =
    featureLoyaltyUi?.loyaltyCTAButtons?.loyaltyBannerHomepageAuthenticatedButton
      ?.loyaltyBannerHomepageAuthenticatedLink?.locale ||
    formatMessage({ id: 'routes.loyaltyDashboard' });

  const navigate = useNavigate();
  const { logNavigationClick } = useCdpContext();
  const { location } = useLocationContext();

  const handleViewMoreClick = () => {
    logNavigationClick(CustomEventNames.BUTTON_CLICK, {
      Name: 'View More Rewards',
      CurrentPath: location.pathname,
      PathTo: rewardsPath,
    });

    navigate(rewardsPath);
  };

  useEffect(() => {
    trackEvent({
      name: CustomEventNames.PAGE_VIEW,
      type: EventTypes.Other,
      attributes: {
        path: pathname,
        pathWithSearch: pathname + search,
        Name: EVENT_PAGE_NAMES.RewardsOffers,
      },
    });
  }, []);

  return (
    <OfferRewardContainer isLoggedIn={isLoggedIn}>
      <PageTitleContainer>
        <PageTitleText>{formatMessage({ id: 'offers' })}</PageTitleText>
      </PageTitleContainer>
      <RewardsTitleRow isLoggedIn={isLoggedIn}>
        <RewardsTitle isLoggedIn={isLoggedIn}>{formatMessage({ id: 'rewards' })}</RewardsTitle>
        {isLoggedIn && (
          <StyledButton onClick={handleViewMoreClick}>
            {formatMessage({ id: 'loyaltyOffersSeeAll' })}
          </StyledButton>
        )}
      </RewardsTitleRow>
      {isLoggedIn ? (
        <InlineCarouselWrapper>
          <LoyaltyRewardsMemo isInline={true} isV2={true} />
        </InlineCarouselWrapper>
      ) : (
        <LoggedOutView />
      )}
    </OfferRewardContainer>
  );
};
